import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import toast from 'features/toast';
import { ICreateAccessorPayload } from 'interfaces';

import { accessorApi } from '../api';
import { getApiErrorMessage } from '../utils';

export const useCreateAccessor = () => {
  const translationPrefix = 'pages.accessories';
  const { t } = useTranslation();
  const navigate = useNavigate();

  const onSubmit = async (values: ICreateAccessorPayload) => {
    try {
      await accessorApi.create(values);
      toast.success(t(`${translationPrefix}.success`));
      navigate('../');
    } catch (error) {
      toast.error(getApiErrorMessage(error, t('pages.accessories.error-generic')));
    }
  };

  return { onSubmit };
};
